module.exports = __webpack_public_path__ + "static/img/23xinku.c8eb0ed6.gif";